module Meevo.Components.Filters {

    export function meevoSmartcenterCurrenyFilter(): any {
        const filter = (input: any): string => {

            if (input.length > 7 && input.indexOf("(") == -1) {
                input = input.slice(0, input.length - 3);
            } else if (input.length > 8 && input.indexOf("(") != -1) {
                input = input.slice(0, input.length - 4) + ")";
            }


            return input;
        }

        return filter;
    }

    angular.module("meevo.components.filters")
        .filter("meevoSmartcenterCurreny", meevoSmartcenterCurrenyFilter);
}